import { Component } from '@angular/core';
import { ActionSheetController,IonicPage, NavController,AlertController, LoadingController, NavParams } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonProvider } from '../../providers/common/common';
import {GenericFormValidationProvider} from "../../providers/common/form-validation"
import { PasswordPage } from '../password/password';
import { ForgotMobileNumberPage } from '../forgot-mobile-number/forgot-mobile-number';
import { CreateNewPasswordPage } from '../create-new-password/create-new-password';
import { HomePage } from '../home/home';
import {OtpPage} from '../otp/otp'


/**
 * Generated class for the UpdateofficialemailPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-updateofficialemail',
  templateUrl: 'updateofficialemail.html',
})
export class UpdateofficialemailPage {

  dailingCodes:any=[];
  errorDisplay:any={};
  email:any;
  officialemail:any
  communicationFlag:any=false;
  official:any="official";
  ccs_remarks:any;
  constructor(public actionSheetCtrl: ActionSheetController,public navCtrl: NavController, public navParams: NavParams,
    private fb: FormBuilder,
    private cp: CommonProvider,
    private alertController: AlertController,
    private fv : GenericFormValidationProvider,
    private loadingCtrl: LoadingController) {
  }

  ionViewDidLoad() {
     
//console.log('ionViewDidLoad Contact details change page',this.navParams);
    

    if(this.navParams.get('updatedemail')){
      
      this.officialemail=this.navParams.data.queryParams.emailid;
      this.email=this.navParams.get('emailid');
       
      this.communicationFlag = this.navParams.data.queryParams.communication
      console.log('ionViewDidLoad Contact details change page',this.communicationFlag,"afterotp",this.email);
      if(this.communicationFlag)
      {
        this.official= "Communication";
      }
      this.updateMobileNumberAfterOtpVerify();
    }else{
      console.log(this.navParams,"update contact")
      this.officialemail=this.navParams.data.queryParams.emailid;
      this.email=this.navParams.data.queryParams.emailid;
       
      this.communicationFlag = this.navParams.data.queryParams.communication
      console.log('ionViewDidLoad Contact details change page',this.communicationFlag);
      if(this.communicationFlag)
      {
        this.official= "Communication";
      }
    }

  }
   
  presentActionSheet(title?:any,msg?:any) {
    const actionSheet = this.actionSheetCtrl.create({
      title: msg,
      cssClass: 'commanSheet',
      buttons: [
        {
          text: "OK",
          role: 'Ok',
          handler: () => {
             actionSheet.dismiss();
          }
        }
      ]
    });
    actionSheet.present();
  } 


 updateMobileNumberAfterOtpVerify(){
     var ccs_casecategory="CC02";
    var ccs_casetype="CT02";
    var ibhfl_loanaccountnumber1=localStorage.getItem('cc');
    var ccs_originatingsource="S011"
    var ccs_casesubtype = "ST109";
    var ccs_remarks = this.ccs_remarks;
    var ibhfl_newemail = this.email;
    var ibhfl_typeofcontactupdate=303710002;
    var ibhfl_customername = this.navParams.data.queryParams.customername;
    var ibhfl_addresstypes = this.communicationFlag?"CURRES":this.navParams.data.queryParams.addresstype;
    var ccs_communicationaddress = this.communicationFlag;

    let loading = this.loadingCtrl.create({
            content: 'Please wait...'
          });
     loading.present()

    this.cp.postContactDetailsUpdateEmailQuery(loading,ccs_casecategory,ccs_remarks,
                           JSON.parse(localStorage.getItem("existingLoan"))[0].customercode,ccs_casetype,
                           ibhfl_loanaccountnumber1,
                           ccs_originatingsource,
                           ccs_casesubtype,ibhfl_customername,
                           ibhfl_typeofcontactupdate,ibhfl_newemail,
                           ibhfl_addresstypes,
                           ccs_communicationaddress).then((res:any)=>{
                            loading.dismiss();
                            var res=JSON.parse(res)
                            this.presentActionSheet(" ","Your SRno. "+res.Payload.caseid+" has been resolved.")
                           })
  }

 postFormForValidation(){
  if(this.email==this.navParams.data.queryParams.emailid){
    this.presentActionSheet("Error","The Email ID you are trying to enter is the same as the one in our records. Please enter a differentEmail ID.");
    return false;
  }
    this.errorDisplay = this.fv.checkValidationFormAllControls(document.forms[0],true,[]);
    //console.log(this.errorDisplay)
    if(this.errorDisplay.valid){
     return false;
   }else{
    // this.updateMobileNumberAfterOtpVerify();
    this.navCtrl.push(OtpPage,{email:this.email,type:"updateemail",queryParams:this.navParams.data.queryParams})
    

                            
   
   }
   }
   
  goToForgotMobile(){
    //this.navCtrl.push(ForgotMobileNumberPage)
  }
}



// WEBPACK FOOTER //
// ./src/pages/updateofficialemail/updateofficialemail.ts